import { MouseEvent } from "react";
import { useEffect, useState } from "react";
import { Button, Box, TextField, Typography } from "@mui/material";

interface FilterProps {
  setSearchText: (text: string | undefined) => void;
  handleBtnClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

const Filter = ({ setSearchText, handleBtnClick }: FilterProps) => {
  const [text, setText] = useState<string>();

  useEffect(() => {
    setSearchText(text);
  }, [text]);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        sx={{
          fontFamily: "Manrope",
          fontWeight: "700 !important",
          lineHeight: "1.2 !important",
          textAlign: "left",
          color: "#6f7d95 !important",
          fontSize: { xs: "1.4rem", md: "1.75rem" },
        }}
      >
        Search for collectors
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "2rem",
          borderRadius: "10px",
          backgroundColor: "white !important",
          minHeight: "50px",
          width: "100%",
          padding: "8px",
          marginBottom: "1rem",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", sm: "66.67%", md: "75%", lg: "75%" },
            boxSizing: "border-box",
            marginBottom: { xs: "16px", sm: "0px" },
          }}
        >
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "50px",
                paddingRight: "0px !important",
                backgroundColor: "white",
                "& fieldset": {
                  border: "none",
                },
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#3c3c40 !important",
                fontWeight: 800,
                fontSize: "16px",
                opacity: 1,
              },
            }}
            placeholder="Search for collector"
            variant="outlined"
            value={text}
            onChange={(e) => setText(e.target.value)}
            fullWidth
          />
        </Box>
        <Box
          sx={{
            width: { xs: "100%", sm: "33.33%", md: "25%", lg: "25%" },
          }}
        >
          <Button
            onClick={handleBtnClick}
            fullWidth
            variant="darkBlue"
            sx={{
              fontFamily: "Manrope",
              paddingTop: "11px",
              paddingBottom: "11px",
              textTransform: "uppercase",
              fontSize: "16px",
              "&:hover": {
                color: "#4695ff",
              },
            }}
          >
            Search Collector
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Filter;
